module.exports = "<div> <layout-class layout=a></layout-class> <collection-mode-context></collection-mode-context> <main role=main> <post-view current-view=currentView() filters=filters> </post-view> </main> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/collections/collections.html
// module id = 826
// module chunks = 0